import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/rotate.svg
 */
const IconRotate: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 13.5v9h9v-9h-9zM.5 12a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5H.5z"
      fill="currentColor"
    />
    <path
      d="M2.873 8.754a.4.4 0 01-.425-.44l.476-4.652a.4.4 0 01.685-.237l4.19 4.329a.4.4 0 01-.26.677l-4.666.323z"
      fill="currentColor"
    />
    <path
      d="M3.58 8.159c-.374-.197-.52-.662-.297-1.021a10.742 10.742 0 1115.529 14.29c-.34.252-.815.145-1.042-.212-.227-.357-.12-.827.216-1.083A9.21 9.21 0 104.643 7.853c-.227.357-.688.502-1.062.306z"
      fill="currentColor"
    />
  </svg>
);

export default IconRotate;
